import React, { useEffect, useState } from 'react';
import className from 'classnames/bind';

import styles from './index.module.sass';
const cx = className.bind(styles);

const Toast = ({ isShow = true, text }) => {
  const [show, setShow] = useState(isShow);

  useEffect(() => {
    setTimeout(() => setShow(isShow), 500);
  }, [isShow]);

  useEffect(() => {
    if (show) {
      setTimeout(() => setShow(false), 3000);
    }
  }, [show]);

  const containerClass = cx({
    container: true,
    show,
  });

  return (
    <div className={containerClass}>
      <div className={styles.toast}>{text}</div>
    </div>
  );
};

export default Toast;
